import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ButtonType } from '@checkmarx/cx-ui';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import SAMLIDPItem from './item';
import AddEditSAMLFormContainer from '../addEditForm';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import { LdapEditMode } from '../../../services/enums/ldap';

@inject('translationsStore', 'samlStore') @observer
export default class SAMLIDPItemContainer extends Component {

    t = this.props.translationsStore.translate;
    samlStore = this.props.samlStore;
    errorDialogTitle;
    errorDialogMessage;

    state = {
        showDeleteDialog: false,
        showErrorDialog: false,
        showLeaveFormDialog: false,
        editMode: false,
        getCurrentSamlIdpServerInProgress: false
    }

    openDeleteServerDialog = () => {

        this.setState({
            showDeleteDialog: true,
            showErrorDialog: false,
            showLeaveFormDialog: false
        });
    }

    closeDeleteDialog = () => {

        this.setState({
            showDeleteDialog: false
        });
    }

    openErrorDialog = (title, message) => {

        this.errorDialogMessage = message;
        this.errorDialogTitle = title;

        this.setState({ 
            showErrorDialog: true,
            showDeleteDialog: false,
            showLeaveFormDialog: false
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            showErrorDialog: false
        }); 
    }

    openLeaveFormDialogHandler = () => {

        this.setState({ 
            showLeaveFormDialog: true,
            showDeleteDialog: false,
            showErrorDialog: false
        }); 
    }

    leaveFormDialogHandler = () => {

        this.setState({ 
            showLeaveFormDialog: false,
            editMode: false
        });

        this.samlStore.toggleIsEditMode();
        this.samlStore.resetForm();
    }

    stayFormDialogHandler = () => {

        this.setState({ 
            showLeaveFormDialog: false
        });
    }

    triggerToastr = (message, level) => {

        ToastrService.triggerToastr({level, message});
    }
    
    deleteIDP = _ => {

        this.samlStore.deleteSAMLIdentityProvider(this.props.id)
            .then(_ => {

                this.closeDeleteDialog();
                this.samlStore.getAllSAMLIdentityProviders();
                
                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.t('SAML_IDP_DELETED_SUCCESS_MESSAGE');
                this.triggerToastr(message, level);
            })
            .catch(err => {
                this.openErrorDialog(this.t('ERROR'), this.samlStore.deleteSAMLIdpsErrorMessage);
            });
    }

    openEditForm = _ => {
        
        if (this.samlStore.isEditMode === true) {
            this.openErrorDialog(this.t('ONLY_ONE_IDP_CAN_BE_EDITED_AT_A_TIME'),
                        this.t('SAVE_OR_CANCEL_THE_CURRENT_FORM_AND_TRY_AGAIN'));
        }
        else {

            this.setState({
                getCurrentSamlIdpServerInProgress: true
            });
            
            this.samlStore.getSAMLIdentityProvider(this.props.id)
                .then(idp => {

                    this.samlStore.setId(idp.id);
                    this.samlStore.setActive(idp.active);
                    this.samlStore.setName(idp.name);
                    this.samlStore.setIssuer(idp.issuer);
                    this.samlStore.setLoginUrl(idp.loginUrl);
                    this.samlStore.setLogoutUrl(idp.logoutUrl || '');
                    this.samlStore.setErrorUrl(idp.errorUrl || '');

                    this.samlStore.setCertificateFileName(idp.certificateFileName);
                    this.samlStore.setCertificateSubject(idp.certificateSubject);
                    this.samlStore.setSignAuthnRequest(idp.signAuthnRequest);
                    this.samlStore.setAuthnRequestBinding(idp.authnRequestBinding);
                    this.samlStore.setIsManualManagement(idp.isManualManagement);
                    this.samlStore.setDefaultTeamId(idp.defaultTeamId);
                    this.samlStore.setDefaultRoleId(idp.defaultRoleId);

                    this.samlStore.setIsMappingEnabled(idp.mapSamlIdpAttributes);
                    this.samlStore.setRoleMappingAttribute(idp.roleMappingAttribute);
                    this.samlStore.setTeamMappingAttribute(idp.teamMappingAttribute);


                    this.setState({
                        editMode: true
                    });
        
                    this.samlStore.toggleIsEditMode();
                })
                .catch(err => {
                    this.openErrorDialog(this.t('ERROR'), this.samlStore.getSAMLIdpErrorMessage);
                })
                .finally(() => {

                    this.setState({
                        getCurrentSamlIdpServerInProgress: false
                    });
                });
        }
    }

    closeForm = _ => this.setState({ 
                        editMode: false
                    });

    componentDidMount() {

        this.samlStore.setIsEditMode(false);
    }

    render() {

        const t = this.props.translationsStore.translate;
        const { deleteSAMLIdpsProgress } = this.samlStore;
        const deleteMessage = 
            <div>
                {this.t('DELETE_IDENTITY_PROVIDER_MESSAGE').replace('{IDP_NAME}', this.props.name)}
                <br />
                {this.props.translationsStore.translate('DELETING_IDENTITY_PROVIDER_CONFIRM_WILL_DELETE_USER')}
            </div>;

        return(
            [
                this.state.editMode === false ? <SAMLIDPItem
                                                    key={1}
                                                    openDeleteServerDialog={this.openDeleteServerDialog}
                                                    openEditForm={this.openEditForm}
                                                    deleteIDP={this.deleteIDP}
                                                    inProgress={this.state.getCurrentSamlIdpServerInProgress}
                                                    {...this.props}
                                                />
                                                    : <AddEditSAMLFormContainer
                                                        key={1}
                                                        editMode={LdapEditMode.update}
                                                        cancelButtonHandler={this.openLeaveFormDialogHandler}
                                                        closeForm={this.closeForm}
                                                      />,
                <DeleteDialog 
                    key={2}
                    show={this.state.showDeleteDialog}
                    onConfirm={this.deleteIDP}
                    deleteButtonText={this.t('DELETE')}
                    cancelText={this.t('CANCEL')}                                
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={this.t('DELETE_IDENTITY_PROVIDER')}
                    contentText={deleteMessage}
                    inProgress={deleteSAMLIdpsProgress}
                    dataCy='btn-delete-idp-server'
                />,
                <ErrorDialog 
                    key={3}
                    show={this.state.showErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.t('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.errorDialogTitle}
                    contentText={this.errorDialogMessage}
                    dataCy='error-dialog-idp-server'
                />,
                <ConfirmationDialog 
                    key={4}
                    open={this.state.showLeaveFormDialog}
                    onButtonClick={this.stayFormDialogHandler}
                    onCancelClick={this.leaveFormDialogHandler}
                    closeClick={this.stayFormDialogHandler}
                    buttonText={this.t('STAY')}
                    cancelButtonText={t('LEAVE')}
                    titleText={t('CONFIRMATION')}
                    contentText={t('ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_FOR_WITHOUT_SAVING')}
                />
            ]
        );
    }
}